export default {
  getReportData: state => state.dadosRelatorio,
}
